import { render } from "./ClassDialog.vue?vue&type=template&id=d59d6f56&ts=true"
import script from "./ClassDialog.vue?vue&type=script&lang=ts"
export * from "./ClassDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__